import { reactive, ref, computed, watch } from '@vue/composition-api'
import store from '@/store'
import * as apiBookmark from '@/api/bookmark'

/**
 * 後で見るボタン
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    /**
     * ブックマーク・後で見るID
     */
    afterId: computed({
      get: () => {
        return props.afterId
      },
      set: (value) => {
        props.afterId = value
      }
    }),

    /**
     * GA計測用class名
     */
    gaClass: computed(() => {
      return props.gaClass
    }),

    /**
     * ボタンがクリックされた場合
     */
    onClicked: () => {

      if (group1.afterId !== 0) {
        // 後で見るがONの場合

        // ブックマーク・後で見る削除APIをコール
        const params = {
          id: group1.afterId
        }

        apiBookmark
          .remove(params)
          .then(response => {
            const data = response.data
            if (data.status === 0) {
              store.dispatch('common/showToast', { text: '後で見るを削除しました。' })
              context.emit('onViewLaterChanged', { id: props.paramId, isAfter: false, afterId: 0 })
            }
          })
      } else {
        // 後で見るがOFFの場合

        // ブックマーク・後で見る追加APIをコール
        const params = {
          type: 2, // 2:後で見る
          key: props.paramKey,
          id: props.paramId
        }

        apiBookmark
          .add(params)
          .then(response => {
            const data = response.data

            if (data.status === 0) {
              const afterId = data.after_id
              store.dispatch('common/showToast', { text: '後で見るに保存しました。' })
              context.emit('onViewLaterChanged', { id: props.paramId, isAfter: true, afterId: afterId })
            }
          })
      }
    }
  })

  return group1
}
